import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromKledning } from "@/components/calculators/lineMappers";
import { kledningCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/kledning")({
  component: KledningPage,
});

function KledningPage() {
  const [area, setArea] = useState<number | "">("");
  const [bredde, setBredde] = useState<number | "">(148);
  const [lengde, setLengde] = useState<number | "">(4.8);
  const [overlapp, setOverlapp] = useState<number | "">(30);
  const [spill, setSpill] = useState<number | "">(10);

  const r = useMemo(() => {
    if (area === "" || bredde === "") return null;
    return kledningCalc({
      area_m2: Number(area),
      bord_bredde_mm: Number(bredde),
      bord_lengde_m: lengde === "" ? undefined : Number(lengde),
      overlapp_mm: overlapp === "" ? undefined : Number(overlapp),
      spill_pct: spill === "" ? undefined : Number(spill),
    });
  }, [area, bredde, lengde, overlapp, spill]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Utvendig kledning" subtitle="Beregn løpemeter kledning og festemateriell." />
      <CalcShell
        title="Inndata"
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Løpemeter bord", value: `${fmt(r.lopemeter, 1)} m`, strong: true },
              { label: "Antall bord",    value: `${fmt(r.antall_bord, 0)} stk` },
              { label: "Spiker/skruer",  value: `${fmt(r.spiker_kg, 2)} kg` },
            ]}
            note="Overlapp gjelder vekselpanel/lockpanel. Sett 0 for glattkant."
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Utvendig kledning`} lines={linesFromKledning(r, Number(bredde))} defaultLaborHours={Math.max(0, Math.round((Number(area) * 0.5) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn areal og bordbredde.</div>}
      >
        <Field label="Kledningsareal" unit="m²"><NumberInput value={area} onChange={setArea} /></Field>
        <Field label="Bord­bredde" unit="mm"><NumberInput value={bredde} onChange={setBredde} /></Field>
        <Field label="Bord­lengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="Overlapp" unit="mm"><NumberInput value={overlapp} onChange={setOverlapp} /></Field>
        <Field label="Svinn" unit="%"><NumberInput value={spill} onChange={setSpill} /></Field>
      </CalcShell>
    </>
  );
}
